import { useQuery } from '@tanstack/react-query';
import { tenantsApi } from '../api/tenants.api';
import type { TenantMemberPaginationParams } from '../types/tenants.types';
import { tenantsKeys } from './queryKeys';

export const useTenantMembers = (tenantId: string, params: TenantMemberPaginationParams = {}) => {
  const { page = 1, pageSize = 10 } = params;

  const { data, isLoading, error } = useQuery({
    queryKey: tenantsKeys.memberList(tenantId, page, pageSize),
    queryFn: () => tenantsApi.getTenantMembers(tenantId, { page, pageSize }),
    enabled: !!tenantId,
  });

  return {
    members: data?.data?.items ?? [],
    pagination: {
      page: data?.data?.page ?? 1,
      pageSize: data?.data?.pageSize ?? 10,
      totalCount: data?.data?.totalCount ?? 0,
      totalPages: data?.data?.totalPages ?? 0,
      hasPreviousPage: data?.data?.hasPreviousPage ?? false,
      hasNextPage: data?.data?.hasNextPage ?? false,
      firstItemOnPage: data?.data?.firstItemOnPage,
      lastItemOnPage: data?.data?.lastItemOnPage,
    },
    isLoading,
    error,
  };
};
